import Typography from '@alltrails/core/components/Typography';
import Link from '@alltrails/denali/components/Link';
import styles from './LinkSection.module.scss';

type LinkSectionProps = {
  heading: string;
  links: { url: string; title: string }[];
  limit?: number;
};

const LinkSection = ({ heading, links, limit = 15 }: LinkSectionProps) => {
  const [firstColumnLinks, secondColumnLinks] = limit === 50 ? [links.slice(0, 25), links.slice(25, 50)] : [links.slice(0, 8), links.slice(8, 15)];

  return (
    <div className={styles.container}>
      <Typography variant="heading200" component="div" className={styles.header}>
        {heading}
      </Typography>
      <div className={styles.columnedSection}>
        <ul className={styles.linksColumn}>
          {firstColumnLinks.map(link => (
            <li key={link.url} className={styles.listItem}>
              <Link href={link.url} size="sm" variant="secondary" noUnderline>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
        <ul className={styles.linksColumn}>
          {secondColumnLinks.map(link => (
            <li key={link.url} className={styles.listItem}>
              <Link href={link.url} size="sm" variant="secondary" noUnderline>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default LinkSection;
